import {Injectable} from '@angular/core';
import { A48ReportTypes } from 'src/app/enums/reports/a48-reports.enum';
import { CplTimeTrackingReportRequest } from 'src/app/model/cpl-time-tracking-report-reqest.model';
import { A48CourseTypes } from 'src/app/model/enum/a48-sub-type.enum';
import { DateHelpers } from '@edl-development/edl-common';
import { SchoolYearSchedule } from 'src/app/model/school-year-schedule';
import { A48ReportPerms } from 'src/app/enums/reports/a48-report-perms.enum';
import { TimeTrackingTypes } from 'src/app/model/enum/cpl-time-tracking-type.enum';

@Injectable()
export class ReportHelpersService {
    a48CourseTypes = new A48CourseTypes();

    getReportRequest = ({ 
        userID, 
        startDate, 
        endDate, 
        type,
        timeType,
        perms,
        showDetails, 
        showUserPicker, 
        shouldGetAll, 
        page,
        limit
    }: {
        userID?: string, 
        startDate?: string, 
        endDate?: string, 
        type?: A48ReportTypes, 
        timeType?: TimeTrackingTypes,
        perms?: A48ReportPerms,
        showDetails?: boolean | string, 
        showUserPicker?: boolean | string, 
        shouldGetAll?: boolean,
        page?: number,
        limit?: number
    }) => {
        const request = new CplTimeTrackingReportRequest();
        const currentSchoolyear = new SchoolYearSchedule();
        request.StartDate = DateHelpers.shortDateStringToDate(startDate ?? currentSchoolyear.StartDate);
        request.EndDate = DateHelpers.shortDateStringToDate(endDate ?? currentSchoolyear.EndDate);
        request.UserID = userID;
        request.Type = type ?? A48ReportTypes.PARAEDUCATOR;
        request.TimeTrackingType = timeType ?? TimeTrackingTypes.ACT48;
        request.Perms = perms ?? A48ReportPerms.ALL;
        request.ShowDetails = (showDetails === 'false' || showDetails === false) ? false : true;
        request.ShowUserPicker = (showUserPicker === 'false' || showUserPicker === false) ? false : true;
        request.ShouldGetAll = shouldGetAll;
        request.Offset = !shouldGetAll ? (page - 1) * limit : 0;
        request.Limit = limit ?? -1;

        return request;
    }

    getCecPerformanceStandard = (cecPerformanceId: number) => {
        const cecPerformance = this.a48CourseTypes.cecPerformance.filter(x => x.id == cecPerformanceId);
        return cecPerformance && cecPerformance.length > 0 ? cecPerformance[0].name : '';
    }

    getTitle = (type: A48ReportTypes, timeType: TimeTrackingTypes) => {
        const roleName = this.getRoleName(type);

        switch(timeType) {
            case TimeTrackingTypes.FLEX:
                return `${roleName} Flex Report`;
            default: 
                return `Act 48 ${roleName} Report`;
        }
    }

    private getRoleName = (type: A48ReportTypes) => {
        switch(type) {
            case A48ReportTypes.EMERGENCY_CERTIFIED:
                return 'Emergency Cert';
            case A48ReportTypes.PARAEDUCATOR:
                return 'Paraeducator';
            default: 
                return 'Teacher';
        }
    }
}